module.exports = __webpack_public_path__ + "img/stats-white.43243016.svg";